<template>
  <Layout>
    <Head title="Profile" />
    <div>
      <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
        <div>
          <TwoFactorAuthenticationForm
            :requires-confirmation="confirmsTwoFactorAuthentication"
            class="mt-10 sm:mt-0"
          />
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import TwoFactorAuthenticationForm from './Partials/TwoFactorAuthenticationForm'
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    TwoFactorAuthenticationForm,
  },
  layout: Layout,
  props: ['confirmsTwoFactorAuthentication', 'sessions'],
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>
